import { render, staticRenderFns } from "./open-pane.vue?vue&type=template&id=07429714"
import script from "./open-pane.vue?vue&type=script&lang=js"
export * from "./open-pane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07429714')) {
      api.createRecord('07429714', component.options)
    } else {
      api.reload('07429714', component.options)
    }
    module.hot.accept("./open-pane.vue?vue&type=template&id=07429714", function () {
      api.rerender('07429714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/detail-pane/components/open-pane.vue"
export default component.exports